/* TSO approved-text catalog search — the "Custom Text" searchable box.
   Selecting a Custom Text variant in the builder opens a searchable panel
   over the FULL personalized_text_options catalog (fetched once from
   /pages/vehicle-data?view=personalized-text-data, localStorage-cached 24h).
   Picking a text routes to the correct single/double-row variant, fills the
   emblem rows read-only, and carries the text's dattum_uuid to the ERP.
   Reuses the powder panel CSS (.tso-powder*) + search loop. */
(function (root) {
  'use strict';

  function rowsOf(t) {
    if (t.rows === 1 || t.rows === 2) return t.rows;
    return (t.row2 && String(t.row2).trim() !== '') ? 2 : 1;
  }
  function filterByCapability(list, doubleCapable) {
    return doubleCapable ? list.slice() : list.filter(function (t) { return rowsOf(t) === 1; });
  }
  function targetOptionValue(rows, doubleCapable) {
    if (!doubleCapable) return 'Custom Text';
    return rows === 2 ? 'Custom Text (Double Row)' : 'Custom Text (Single Row)';
  }
  function matches(t, q) {
    if (!q) return true;
    return String(t.text || '').toLowerCase().indexOf(String(q).toLowerCase()) !== -1;
  }
  function sortTexts(list) {
    return list.slice().sort(function (a, b) {
      return String(a.text || '').localeCompare(String(b.text || ''), undefined, { sensitivity: 'base' });
    });
  }
  // Control/placeholder entries ("Custom Text", "…(Single Row)", "…(Double Row)")
  // carry a blank row1 — they're represented by the "Add your own" buttons, not
  // pickable catalog rows. A real approved text always has row1.
  function pickableTexts(list) {
    return list.filter(function (t) { return t.row1 && String(t.row1).trim() !== ''; });
  }

  var api = { rowsOf: rowsOf, filterByCapability: filterByCapability, targetOptionValue: targetOptionValue, matches: matches, sortTexts: sortTexts, pickableTexts: pickableTexts };

  // CommonJS (tests) — return before touching the DOM.
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }

  // ---- browser-only below ----
  root.TSOTextPicker = api;

  var CACHE_KEY = 'tso_text_data';
  var TTL_MS = 24 * 60 * 60 * 1000;
  var DATA_URL = '/pages/vehicle-data?view=personalized-text-data';
  var ROW_LIMIT = 80;
  var dataPromise = null;

  function fetchCatalog() {
    if (dataPromise) return dataPromise;
    dataPromise = new Promise(function (resolve) {
      try {
        var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
        if (cached && cached.t && Date.now() - cached.t < TTL_MS && Array.isArray(cached.texts) && cached.texts.length) {
          return resolve(cached.texts);
        }
      } catch (e) { /* corrupt cache -> refetch */ }
      function getPage(n, pp) {
        return fetch(DATA_URL + '&' + (pp || 'page') + '=' + n).then(function (r) { return r.json(); });
      }
      getPage(1).then(function (first) {
        var pp = first.page_param || 'page';
        var total = Math.max(1, parseInt(first.pages, 10) || (first.has_next ? 2 : 1));
        var rest = [];
        for (var n = 2; n <= total; n++) rest.push(getPage(n, pp).catch(function () { return { texts: [] }; }));
        Promise.all(rest).then(function (pages) {
          var all = (first.texts || []).slice();
          pages.forEach(function (d) { all = all.concat(d.texts || []); });
          if (all.length) { try { localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), texts: all })); } catch (e) {} }
          resolve(all);
        });
      }).catch(function () { resolve([]); });
    });
    return dataPromise;
  }
  api.fetchCatalog = fetchCatalog;

  var panel = null, activeCtx = null;

  function closePanel() {
    if (panel && panel.parentNode) panel.parentNode.removeChild(panel);
    panel = null; activeCtx = null;
  }

  // Set the Text-Options control to `value` and replay the builder's update so
  // price/SKU/reveal run. Main = radios (.value-item), popup = <select>.
  function routeVariant(ctx, value) {
    if (ctx.surface === 'popup') {
      var $sel = window.jQuery(ctx.popup).find('.accessories-popup-select.variant-options');
      // choose the select whose options include `value`
      $sel.each(function () {
        if (window.jQuery(this).find('option').filter(function () { return this.value === value; }).length) {
          window.jQuery(this).val(value).trigger('change');
        }
      });
    } else {
      // main: check the radio whose value === value inside its .option-steps group
      var $item = window.jQuery('.option-steps .value-item[value="' + value.replace(/"/g, '\\"') + '"]');
      if ($item.length) {
        $item.prop('checked', true);
        // replay the same chain the .value-item click handler runs
        var inst = window.__cpbInstance;
        if (inst) { inst.updateOptionVisibility(); inst.updateCustomBuildProductAttrs(); inst.cpbEvaluateGates(); }
      }
    }
  }

  function inputsIn(ctx) {
    var sel = ctx.surface === 'popup' ? '.personalize-wrap-acc' : '.personalize-wrap-main';
    var scope = ctx.surface === 'popup' ? ctx.popup : document;
    return window.jQuery(scope).find(sel);
  }

  function applyPick(ctx, t) {
    window.__cpbTextApplying = true;
    try {
      var rows = rowsOf(t);
      routeVariant(ctx, targetOptionValue(rows, ctx.doubleCapable));
      // reveal now shows `rows` boxes; fill them read-only
      var $wraps = inputsIn(ctx);
      $wraps.each(function () {
        var $w = window.jQuery(this);
        var r = Number($w.attr('data-row'));
        var $in = $w.find('.personalize-input');
        if (r === 1) $in.val(t.row1 || t.text || '');
        else if (r === 2) $in.val(t.row2 || '');
        $in.prop('readonly', r <= rows);
        $in.trigger('input');
      });
      ctx.root.setAttribute('data-tso-text-uuid', t.uuid || '');
      closePanel();
    } finally {
      window.__cpbTextApplying = false;
    }
  }

  function applyAddYourOwn(ctx, rows) {
    window.__cpbTextApplying = true;
    try {
      routeVariant(ctx, targetOptionValue(rows, ctx.doubleCapable));
      inputsIn(ctx).find('.personalize-input').prop('readonly', false).val('');
      ctx.root.removeAttribute('data-tso-text-uuid');
      closePanel();
    } finally {
      window.__cpbTextApplying = false;
    }
  }

  function open(ctx) {
    closePanel();
    activeCtx = ctx;
    panel = document.createElement('div');
    panel.className = 'tso-powder'; // reuse powder panel styling
    panel.innerHTML =
      '<div class="tso-powder__bar">' +
      '<input type="search" class="tso-powder__input" placeholder="Search approved text" aria-label="Search approved text">' +
      '<button type="button" class="tso-powder__close" aria-label="Close"></button>' +
      '</div>' +
      '<div class="tso-powder__list" role="listbox"><div class="tso-powder__note">Loading…</div></div>';
    ctx.block.appendChild(panel);
    // branded close X (icon-close is server-rendered; clone its two lines here)
    panel.querySelector('.tso-powder__close').innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">' +
      '<path d="M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M18 6L6 18" stroke="#ff9113" stroke-width="2" stroke-linecap="round"/></svg>';
    panel.querySelector('.tso-powder__close').addEventListener('click', closePanel);
    var input = panel.querySelector('.tso-powder__input');
    var listEl = panel.querySelector('.tso-powder__list');
    fetchCatalog().then(function (all) {
      if (!panel) return;
      var sorted = sortTexts(pickableTexts(filterByCapability(all, ctx.doubleCapable)));
      function render() {
        var q = input.value.trim().toLowerCase();
        var hits = [];
        for (var i = 0; i < sorted.length && hits.length < ROW_LIMIT; i++) if (matches(sorted[i], q)) hits.push(sorted[i]);
        listEl.innerHTML = '';
        hits.forEach(function (t) {
          var row = document.createElement('button');
          row.type = 'button'; row.className = 'tso-powder__row'; row.setAttribute('role', 'option');
          row.innerHTML = '<span class="tso-powder__name"></span><span class="tso-powder__code"></span>';
          row.querySelector('.tso-powder__name').textContent = t.text || '';
          row.querySelector('.tso-powder__code').textContent = '(' + rowsOf(t) + ' row)';
          row.addEventListener('click', function () { applyPick(ctx, t); });
          listEl.appendChild(row);
        });
        if (!hits.length) listEl.innerHTML = '<div class="tso-powder__note">No matches</div>';
        // "Add your own" pinned at bottom
        var add1 = document.createElement('button');
        add1.type = 'button'; add1.className = 'tso-powder__row tso-powder__row--add';
        add1.innerHTML = '<span class="tso-powder__name">+ Add your own (1 row)</span>';
        add1.addEventListener('click', function () { applyAddYourOwn(ctx, 1); });
        listEl.appendChild(add1);
        if (ctx.doubleCapable) {
          var add2 = document.createElement('button');
          add2.type = 'button'; add2.className = 'tso-powder__row tso-powder__row--add';
          add2.innerHTML = '<span class="tso-powder__name">+ Add your own (2 rows)</span>';
          add2.addEventListener('click', function () { applyAddYourOwn(ctx, 2); });
          listEl.appendChild(add2);
        }
      }
      var tmr; input.addEventListener('input', function () { clearTimeout(tmr); tmr = setTimeout(render, 120); });
      render(); input.focus();
    });
  }
  api.open = open;
  api.closePanel = closePanel;
})(typeof window !== 'undefined' ? window : this);
